module.exports = __webpack_public_path__ + "img/UI_common_framelabelPX_01_745759551.png";